import { AxiosError }           from "axios";
import { useEffect, useState }  from "react";
import msalRestClient           from "../../../services/clients/MsalRestClient";
import CountryTableEntry        from "./CountryTableEntry";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { CountryTable, EntryMode, PostCountryTable, PutCrossCountryEntry } from "../../../models/Admin/CountryTables";

const CountryTableCreate = () => {

    // #region Init State

    let initTable: PostCountryTable = {
        name        : '',
        description : '',
        countrySet  : []
    }

    // #endregion

    // #region State & Hooks

    const [table,  setTable]  = useState<PostCountryTable>(initTable);
    const [errors, setErrors] = useState<string[]>([]);

    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {

        if (id !== undefined) {

            msalRestClient.get<CountryTable>("/api/countrytables/" + id)
                .then(response => {
                    if (response.status === 200) {
                        setTable({
                            description: response.data.description,
                            name: response.data.name + " - Copy",
                            countrySet: response.data.countrySet.map(x => ({ id: 0, sourceCountryId: x.sourceCountryId, targetCountryId: x.targetCountryId, refundRate: x.refundRate, mode: EntryMode.Display }))
                        })
                    }
                })
        }
    }, []);

    // #endregion

    /**
     * TBD ...
     * @param entry
     * @param index
     */
    const onSubmitEntry = (entry: PutCrossCountryEntry, index: number) => {

        let countrySets = table.countrySet.map((item, i) => (i === index ? entry : item));
        setTable(x => ({ ...x, countrySet: countrySets }));
    }

    /**
     * TBD ...
     * @param index
     */
    const onDeleteEntry = (index: number) => { 

        let countrySet = table.countrySet.filter((x, i) => i !== index);
        setTable(x => ({ ...x, countrySet: countrySet }));
    }

    /**
     * Callback function called by clicking the "Create New" Button
     */
    const onNewEntryClick = () => {
        let newEntry: PutCrossCountryEntry = {
            id              : -1,
            sourceCountryId : 0,
            targetCountryId : 0,
            refundRate      : 0,
            mode            : EntryMode.Create
        }

        setTable(x => ({ ...x, countrySet: [...x.countrySet, newEntry] }));
    }

    /**
     * TBD ...
     */
    async function onSubmit(): Promise<void> {

        msalRestClient.post<CountryTable>("/api/countrytables", table)
            .then(response => {
                if (response.status === 200) { navigate("/admin/countries"); }
            })
            .catch((err: AxiosError) => {
                if (err.response!.status === 422) {
                    if (err.response?.data && (err.response.data as string)) {
                        setErrors([err.response.data as string]);
                    }
                }
            })
    }

    /**
     * Render function for render a error pane.
     * @returns JSX Element thats presents a list of error messages to user.
     */
    const renderErrorPane = () => {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="alert alert-danger">
                        <p className="fw-bold mb-0">Whoops! There were some problems with your input.</p>
                        <ul className="mb-0">
                            {
                                errors.map((value, index) => {
                                    return (
                                        <li key={"err_" + index}>{value}</li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <main className="container mb-4">

            <div className="row mb-2">
                <div className="col-12 text-end">
                    <NavLink to="/admin/countries" className="btn btn-danger">
                        <i className="bi bi-x-lg" />
                    </NavLink>
                </div>
            </div>

            <div className="row">
                <div className="col-12">

                    <div className="card">
                        <div className="card-body">

                            {(errors.length > 0) && renderErrorPane()}

                            <div className="form-group col-md-12">
                                <label className="fw-bold" htmlFor="tableName">Tablename</label>
                                <input type="text" className="form-control" id="tableName" name="tableName" value={table.name} onChange={e => setTable(x => ({ ...x, name: e.target.value }))} />
                            </div>

                            <div className="form-group col-md-12">
                                <label className="fw-bold" htmlFor="description">Description</label>
                                <textarea cols={1} rows={5} className="form-control" id="description" value={table.description} name="description" onChange={e => setTable(x => ({ ...x, description: e.target.value }))} />
                            </div>

                            <div className="col-12">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th colSpan={4}>
                                                <button className="btn btn-success" onClick={e => onNewEntryClick()}>
                                                    <i className="bi bi-plus-lg me-1"></i>Add new Country Pair
                                                </button>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Origin Country</th>
                                            <th>Destination Country</th>
                                            <th>Refund</th>
                                            <th>
                                                { /* Empty for controls */ }
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            table.countrySet.map((value, index) => {
                                                return <CountryTableEntry index={index} value={value} onConfirm={onSubmitEntry} onDelete={onDeleteEntry} />
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div className="card-footer text-end">
                            <button className="btn btn-success" onClick={onSubmit}><i className="bi bi-check-lg me-1"></i>Validate and Create</button>
                        </div>

                    </div>

                </div>
            </div>

        </main>
    )

}
export default CountryTableCreate;
